var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
const SvgIconTable = props => /*#__PURE__*/React.createElement("svg", _extends({
  xmlns: "http://www.w3.org/2000/svg",
  viewBox: "0 0 24 24"
}, props), _g || (_g = /*#__PURE__*/React.createElement("g", {
  fill: "none"
}, /*#__PURE__*/React.createElement("path", {
  d: "M0 0h24v24H0z"
}), /*#__PURE__*/React.createElement("path", {
  fill: "#006C8E",
  d: "M22.5 19.5a2 2 0 0 1-2 2h-17a2 2 0 0 1-2-2v-15a2 2 0 0 1 2-2h17a2 2 0 0 1 2 2v15z"
}), /*#__PURE__*/React.createElement("path", {
  fill: "#D3F4FF",
  d: "M16.17 17.25h4.335v2.25H16.17v-2.25zm-6.335 0h4.335v2.25H9.835v-2.25zm-6.335 0h4.335v2.25H3.5v-2.25zM16.17 13h4.335v2.25H16.17V13zm-6.335 0h4.335v2.25H9.835V13zM3.5 13h4.335v2.25H3.5V13zm12.67-4.25h4.335V11H16.17V8.75zm-6.335 0h4.335V11H9.835V8.75zm-6.335 0h4.335V11H3.5V8.75zm0-4.25h17v2.25h-17V4.5z"
}))));
export default SvgIconTable;